import withCreatePathItem from "@pathwright/web/src/modules/path/graphql/withCreatePathItem"
import withDeletePathItem from "@pathwright/web/src/modules/path/graphql/withDeletePathItem"
import withPastePathItem from "@pathwright/web/src/modules/path/graphql/withPastePathItem"
import withUpdatePathItem from "@pathwright/web/src/modules/path/graphql/withUpdatePathItem"
import defaults from "lodash/defaults"
import compose from "lodash/flowRight"
import React from "react"

export const withPathItemMutations = (Component) => {
  class SavePathItem extends React.Component {
    savePathItem = async (data) => {
      const pathAdminStore = App.getStore("pathAdmin")
      const pathStore = App.getStore("path")
      const { selection } = pathAdminStore.getState()

      // TODO: fix error where order is not provided!
      // Check for root item insertion
      if (selection.order === 0) {
        selection.order = 1
      }

      const itemData = defaults({}, data, selection, {
        pathId: pathStore.get("path").id, // for withCreatePathItem
        path_id: pathStore.get("path").id // for withUpdatePathItem
      })

      switch (itemData.item_type) {
        case "T":
          itemData.type = "divider"
          break
        case "G":
          itemData.type = "lesson"
          break
        case "A":
          itemData.type = "step"
          break
        case "R":
          itemData.type = "resource"
          break
      }

      pathAdminStore._mutate({
        is_saving_selection: true,
        selection_error: null
      })

      const isNew = !itemData.id

      try {
        if (isNew) {
          await this.props.createPathItem(itemData)
          pathAdminStore.storeTrigger("path:item:created")
        } else {
          await this.props.updatePathItem(itemData)
          pathAdminStore.storeTrigger("path:item:updated")
        }
      } catch (error) {
        pathAdminStore._mutate({ selection_error: error })
      } finally {
        pathAdminStore._mutate({
          is_saving_selection: false,
          editing_selection: null,
          archiving_selection: null
        })
      }
    }

    archivePathItem = async (data) => {
      const pathAdminStore = App.getStore("pathAdmin")
      const pathStore = App.getStore("path")

      const itemData = defaults({}, data, {
        path_id: pathStore.get("path").id // for withDeletePathItem
      })

      pathAdminStore._mutate({ is_saving_selection: true })

      try {
        await this.props.deletePathItem(itemData)
        pathAdminStore.storeTrigger("path:item:archived")
      } catch (error) {
        pathAdminStore._mutate({ selection_error: error })
      } finally {
        pathAdminStore._mutate({ is_saving_selection: false })
      }
    }

    render() {
      return (
        <Component
          {...this.props}
          savePathItem={this.savePathItem}
          archivePathItem={this.archivePathItem}
        />
      )
    }
  }

  SavePathItem.displayName = "SavePathItem"

  const ComponsedComponent = compose(
    withCreatePathItem,
    withUpdatePathItem,
    withDeletePathItem,
    withPastePathItem
  )(SavePathItem)

  return ComponsedComponent
}

export default withPathItemMutations
